module.exports = __webpack_public_path__ + "457bf64d93cbf130e1f5b41c2f03dcb6.MP3";